import { render } from "./BuildMessage.vue?vue&type=template&id=2d1d0d2c&ts=true"
import script from "./BuildMessage.vue?vue&type=script&lang=ts"
export * from "./BuildMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__